module.exports = __webpack_public_path__ + "img/G4.5f88fcd5.png";